var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-form-modal",
    {
      staticClass: "user-assign-project-form-modal",
      attrs: {
        title: "Gebruiker(s) toewijzen aan project",
        "submit-button": "Toewijzen",
        submitting: _vm.submitting,
      },
      on: { close: _vm.cancel, submit: _vm.submit },
    },
    [
      _c("search-dropdown", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'",
          },
        ],
        attrs: {
          title: "Project",
          name: "projectId",
          "data-vv-name": "projectId",
          "data-vv-as": "Project",
          options: _vm.projectOptions,
          searchable: true,
          "max-height": "100",
          error: _vm.error("projectId"),
        },
        on: { "query-changed": _vm.onSearchQueryChanged },
        model: {
          value: _vm.projectId,
          callback: function ($$v) {
            _vm.projectId = $$v
          },
          expression: "projectId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }